import { Button } from "@mui/material";

import { GridItem, GridRow } from "commons/ui/Grid";

import ShowroomForm from "components/form/ShowroomForm";

import { SaveContextProvider } from "context/save";

import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Showroom creato con successo",
        errorMsg: "Errore nella creazione dello showroom",
        navigateTo: { link: "/showroom" },
    });

    return (
        <GridRow justifyContent={"right"}>
            <GridItem className={"button-under-paper"}>
                <Button variant={"contained"} onClick={onButtonClick}>
                    Salva
                </Button>
            </GridItem>
        </GridRow>
    );
}

function NuovoShowroom() {
    return (
        <>
            <GridRow className={"title-top-paper"}>
                <GridItem>
                    <h1>Aggiungi Showroom</h1>
                </GridItem>
            </GridRow>

            <SaveContextProvider>
                <ShowroomForm />

                <ButtonSave />
            </SaveContextProvider>
        </>
    );
}

export default NuovoShowroom;
